import { Dropdown, Button, Flex } from 'antd';
import { IconLanguage, IconChevronDown } from '@tabler/icons-react';
import { LanguageSwitcherProps } from '@evimo/components/LanguageSwitcher/LanguageSwitcher.types';
import {
  getButtonStyle,
  dropdownMenuStyle,
} from '@evimo/components/LanguageSwitcher/LanguageSwitcher.style';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher = (props: LanguageSwitcherProps) => {
  const { t } = useTranslation('common');
  const { currentLanguage, items, onMenuClick, withinMenu, flag, collapsed } =
    props;
  if (withinMenu) {
    return (
      <Dropdown
        menu={{
          items,
          onClick: onMenuClick,
          selectedKeys: [currentLanguage],
          style: dropdownMenuStyle,
        }}
        trigger={['click']}
        className="language-dropdown"
      >
        {flag && (
          <Flex align="center" gap={4}>
            <span style={{ fontSize: 24, lineHeight: 1, display: 'block' }}>
              {flag}
            </span>
            {!collapsed && (
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: 'uppercase',
                }}
              >
                {t(`common:languages.${currentLanguage}`)}
              </span>
            )}
          </Flex>
        )}
      </Dropdown>
    );
  }
  return (
    <Dropdown
      menu={{
        items,
        onClick: onMenuClick,
        selectedKeys: [currentLanguage],
        style: dropdownMenuStyle,
      }}
      trigger={['click']}
      className="language-dropdown"
    >
      <Button style={getButtonStyle(props)}>
        <Flex align="center" gap={4}>
          {flag && (
            <Flex align="center" style={{ fontSize: '16px' }}>
              {flag}
            </Flex>
          )}
          <IconLanguage size={withinMenu ? 50 : 18} stroke={1.8} />
          {!withinMenu && (
            <IconChevronDown size={14} stroke={3} style={{ opacity: 0.6 }} />
          )}
        </Flex>
      </Button>
    </Dropdown>
  );
};
